'use client';

import { useEffect } from 'react';
import LogRocket from 'logrocket';
import { useAuth } from './AuthContext';
import { usePlans } from './PlansContext';

/**
 * Calls LogRocket.identify when user is logged in, including subscriptionType from plan.
 * Must be rendered inside both AuthProvider and PlansProvider.
 */
export function LogRocketIdentify() {
  const { user } = useAuth();
  const { planType } = usePlans();

  useEffect(() => {
    if (!user) return;
    LogRocket.identify(user.id, {
      name: user.name,
      email: user.email,
      subscriptionType: planType,
      ...(user.credits != null && { credits: user.credits }),
      ...(user.currentWorkspaceId && { currentWorkspaceId: user.currentWorkspaceId }),
    });
  }, [user, planType]);

  return null;
}
